module.exports = __webpack_public_path__ + "static/collabion-19f95e370fbf6628b3d603d2888da9c7.svg";